import { createSelector } from 'reselect';

const selectLoanApplications = ({ loanApplications }) => loanApplications;

export const selectLoanApplicationsList = createSelector(selectLoanApplications, Object.values);
